var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWellbeing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.45312 0.526581H14.5469C15.3467 0.526581 16 1.19272 15.9971 2.01181V14.9903C15.9971 15.8062 15.3467 16.4724 14.5439 16.4724H1.45312C0.65332 16.4724 0 15.8095 0 14.9903V2.00864C0 1.19272 0.65332 0.526581 1.45312 0.526581ZM8 14.6206H14V2.38156H8V14.6206Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWellbeing);
export default __webpack_public_path__ + "static/media/wellbeing.a5212d1406296f6712eff271bce72c40.svg";
export { ForwardRef as ReactComponent };